import Decimal from 'decimal.js';

const displayAmount = amount => amount ? (new Decimal(amount)).toFixed(4) : '';

export default displayAmount;
